<template>
    <div>
        <h2 class="page-title">Cheerio REPL</h2>
        <div class="columns">
            <div class="column" v-if="left">
                <CodeMirror
                        v-model="inputHtml"
                        :options="cmOptions"
                        ref="editor"
                />
                <div class="buttons">
                    <b-button @click="prettify">Prettify</b-button>
                    <b-button @click="load">cheerio.load</b-button>
                </div>
            </div>
            <div class="column">
                <Repl ref="repl" :globals="{ cheerio }" :class="left ? '' : 'repl-full-width'">
                    <b-button class="hide-btn" @click="left = !left">{{left ? '&lt; hide' : '&gt; show'}}</b-button>
                </Repl>
            </div>
        </div>
    </div>
</template>

<script>
import cheerio from 'cheerio'
import { html } from 'js-beautify'
import Repl from './components/Repl.vue'


const ellipsisMiddle = (s, len) => {
    if (s.length <= len) return s
    let l = (len - 3) / 2
    return s.substring(0, l % 1 === 0 ? l : Math.round(l)) + '...' + s.substring(s.length - l)
}

export default {
    name: 'app',
    components: {
        Repl,
        CodeMirror: () => import('./cm-bundle'),
    },
    data: () => ({
        cheerio,
        left: true,
        cmOptions: {
            mode: 'text/html',
            theme: 'default',
            lint: true,
            lineNumbers: true,
            foldGutter: true,
            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
            autoCloseTags: true,
            styleActiveLine: true,
            extraKeys: {
                'Ctrl-Space': 'autocomplete',
                Tab (cm) {
                    if (cm.execCommand('emmetExpandAbbreviation') !== true) {
                        if (cm.somethingSelected()) {
                            cm.indentSelection('add')
                        } else {
                            cm.replaceSelection(Array(cm.getOption('indentUnit') + 1).join(' '), 'end', '+input')
                        }
                    }
                },


            },
            placeholder: '<html>...</html>',
            indentUnit: 4,
        },
        inputHtml: '',
    }),
    methods: {
        prettify () {
            this.inputHtml = html(this.inputHtml, {
                indentSize: 4,
            })
        },
        load () {
            let it = {
                expr: `$ = cheerio.load(${JSON.stringify(ellipsisMiddle(this.inputHtml, 25))})`,
            }
            this.$refs.repl.addResult(it)
            try {
                this.$refs.repl.sandbox.window.$ = cheerio.load(this.inputHtml)
            } catch (e) {
                this.$set(it, 'error', e)
            }
        },

    },
    watch: {
        left (v) {
            localStorage.left = v
        },
    },
    mounted () {
        if (!localStorage.left) {
            localStorage.left = 'true'
        }
        this.left = localStorage.left === 'true'
    },
}

window.cheerio = cheerio
</script>

<style>
.page-title {
    font-size: 21px;
    font-weight: 500;
    text-align: center;
    border-bottom: 1px solid #dbdbdb;
    margin: 8px 25%;
    padding: 4px;
}

.is-family-monospace textarea, .is-family-monospace input {
    font-family: monospace !important;
}

.vue-codemirror {
    margin: 8px 0;
}

.CodeMirror, .vue-codemirror {
    line-height: 1em;
    font-family: monospace;
    height: 100% !important;
    max-height: 80vh !important;
    position: relative;
    overflow: hidden;
    width: 45vw;
    max-width: 45vw;
}

.CodeMirror-scroll {
    overflow: auto;
    height: 100%;
    position: relative;
    outline: none;
}

.hide-btn {
    margin-right: 8px;
}

.repl-full-width {
    width: 100% !important;
    max-width: 100% !important;
}
</style>
